import Modal from "react-modal";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { closeModal } from "../../redux/slices/modalSlice";

interface Props {
  isOpen: boolean;
  logo: string;
  onConfirm: () => void;
}

export default function RequestSentModal({
  isOpen,
  logo,
  onConfirm,
}: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch(closeModal("requestSentModal"));
    onConfirm();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Request Sent Confirmation"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          width: "400px",
          padding: "20px",
          borderRadius: "10px",
          inset: "unset",
          backgroundColor: "#fff",
          textAlign: "center",
          position: "relative",
        },
      }}
    >
      {/* CLOSE BUTTON */}
      <button onClick={handleClose} className="modal-close-btn">
        &times;
      </button>

      {/* TITLE */}
      <h2 className="modal-title">
        {t("MyCCOPro.SearchCandidate.requestSent")}
      </h2>

      {/* ICON */}
      <div className="modal-icon-wrapper">
        <img src={logo} alt="Success Icon" className="success-icon" />
      </div>

      {/* ACTION */}
      <button onClick={handleClose} className="modal-primary-btn">
        {t("MyCCOPro.SearchCandidate.ok")}
      </button>
    </Modal>
  );
}
